import type { SubprocesStatus } from '../../../../entity/subprocessen/types/Subproces'
import { SubprocesTypes } from '../../../../entity/subprocessen/types/Subproces'
import { getStatusLabelForType } from '../../../../entity/subprocessen/util/subproces-util'
import { initialState } from '../../../subprocessen/services/searchSubprocessen'
import { useWerklijsten } from '../../hooks/useWerklijsten'
import { DashboardCard } from '../DashboardCard'
import { KpiButton } from '../KpiButton'

interface Props {
  type: string
  status: string
  count: number
  red: number
  amber: number
  green: number
  onClickTile: (query: any, url: string) => void
}

export default function SubprocesTile({
  type,
  status,
  count,
  onClickTile,
  red,
  amber,
  green,
}: Props) {
  const { filters } = useWerklijsten()

  const statusLabel = getStatusLabelForType(
    type as keyof typeof SubprocesTypes,
    status as keyof typeof SubprocesStatus,
  )

  const onClick = (kpiColor?: string) => {
    const query = {
      filters: {
        ...initialState.query.filters,
        ...filters,
        type: [{ code: type, label: SubprocesTypes[type] }],
        status: [{ code: status, label: statusLabel }],
        due: false,
      },
      page: initialState.query.page,
      sort: initialState.query.sort,
    }

    if (kpiColor) {
      query.filters.kpi = kpiColor
    }

    onClickTile(query, '/aansluiting/subprocessen')
  }

  return (
    <DashboardCard
      onClick={() => {
        onClick()
      }}
      label={statusLabel}
      count={count}
      actions={
        <>
          {red > 0 && (
            <KpiButton
              color={'red'}
              count={red}
              onClick={(e) => {
                e.stopPropagation()
                onClick('red')
              }}
            />
          )}
          {amber > 0 && (
            <KpiButton
              color={'amber'}
              count={amber}
              onClick={(e) => {
                e.stopPropagation()
                onClick('amber')
              }}
            />
          )}
          {green > 0 && (
            <KpiButton
              color={'green'}
              count={green}
              onClick={(e) => {
                e.stopPropagation()
                onClick('green')
              }}
            />
          )}
        </>
      }
    />
  )
}
